"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=(e="stencils")=>e+"-"+Math.floor(Math.random()*Number.MAX_SAFE_INTEGER);